import { colors } from '@globals/themes/defaultTheme'
import { tabletQuery } from '@globals/themes/themeConstants'
import CloseFullscreenOutlinedIcon from '@mui/icons-material/CloseFullscreenOutlined'
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined'
import Fab from '@mui/material/Fab'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { MOBILE_BOTTOM_NAV_HEIGHT } from '@nav/Nav.constants'
import { T } from '@transifex/react'
import { forwardRef, useEffect } from 'react'

const buttonStyle = {
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1000,
  color: colors.grayDark,
  backgroundColor: colors.white,
  '&:hover': {
    backgroundColor: colors.blueExtraLight,
  },
  '&:active': {
    backgroundColor: colors.blueExtraLight,
  },
  [tabletQuery]: {
    bottom: `${MOBILE_BOTTOM_NAV_HEIGHT + 8}px`,
    right: 16,
  },
}

type OnboardingGuideFabProps = {
  onClick: () => void
  isDialogOpen: boolean
}

const OnboardingGuideFab = forwardRef<HTMLButtonElement, OnboardingGuideFabProps>(
  ({ onClick, isDialogOpen }, ref) => {
    const isTablet = useMediaQuery(tabletQuery)

    // Expose a CSS variable while the FAB is mounted so other components can reserve space
    useEffect(() => {
      document.documentElement.style.setProperty('--onboarding-fab-offset', '128px')
      return () => {
        document.documentElement.style.removeProperty('--onboarding-fab-offset')
      }
    }, [])

    return (
      <Fab
        id="onboarding-guide-fab" // used to reserve space for the FAB on mobile, do not change this ID
        ref={ref}
        color="primary"
        variant="extended"
        onClick={onClick}
        sx={buttonStyle}
        aria-label="Open onboarding guide">
        {isDialogOpen ? (
          <>
            <CloseFullscreenOutlinedIcon sx={{ mr: isTablet ? 0 : 1, color: colors.grayDark }} />
            {!isTablet && (
              <Typography>
                <T _str="Minimize setup guide" />
              </Typography>
            )}
          </>
        ) : (
          <>
            <OpenInFullOutlinedIcon sx={{ mr: isTablet ? 0 : 1, color: colors.grayDark }} />
            {!isTablet && (
              <Typography>
                <T _str="Expand setup guide" />
              </Typography>
            )}
          </>
        )}
      </Fab>
    )
  },
)

OnboardingGuideFab.displayName = 'OnboardingGuideFab'

export default OnboardingGuideFab
